import { MUNICIPI_INICIALITZAR } from '../../actions/actionTypes';

const ESTAT_INICIAL = null;

const tots = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case MUNICIPI_INICIALITZAR:
            return action.municipis || ESTAT_INICIAL;
        default:
            return state;
    }
};

export default tots;



// WEBPACK FOOTER //
// ./src/reducers/municipis/tots.js